import { useEffect } from 'react';
import { useAuthStore } from '../store/auth';
import { userApi } from '../api/user';
import { requestPersistentStorage } from '../data';

export function AuthInit({ children }: { children: React.ReactNode }) {
  const token = useAuthStore((s) => s.accessToken);
  const user = useAuthStore((s) => s.user);
  const mode = useAuthStore((s) => s.mode);
  const setUser = useAuthStore((s) => s.setUser);

  useEffect(() => {
    if (token && !user) {
      userApi.getMe().then(setUser).catch(() => {});
    }
  }, [token, user, setUser]);

  useEffect(() => {
    // 本地模式：请求持久化存储，降低 IndexedDB 被回收的概率
    if (mode === 'local') void requestPersistentStorage();
  }, [mode]);

  return <>{children}</>;
}
